import { render, staticRenderFns } from "./ExerciseAnswer.vue?vue&type=template&id=b5b5fde6&scoped=true&"
import script from "./ExerciseAnswer.vue?vue&type=script&lang=js&"
export * from "./ExerciseAnswer.vue?vue&type=script&lang=js&"
import style0 from "./ExerciseAnswer.vue?vue&type=style&index=0&id=b5b5fde6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b5fde6",
  null
  
)

export default component.exports